<template>
  <li class="c-entrepneur-vertical-name-list">
    <ul class="c-entrepneur-vertical-name-list__list">
      <entrepreneur-vertical-name-item v-for="index in 5" :key="index" :first-name="firstName" :last-name="lastName" />
    </ul>
  </li>
</template>

<script>
import EntrepreneurVerticalNameItem from "components/EntrepreneurVerticalName/EntrepreneurVerticalNameItem";
import Icon from "objects/Icon";
export default {
  components: {
    EntrepreneurVerticalNameItem,
    Icon
  },
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.c-entrepneur-vertical-name-list {
  display: flex;
  @media #{$breakpoint-horizontal} {
    padding-bottom: var(--grid-gutter-half);
  }
  &__list {
    @include reset-list;
    display: flex;
    flex-direction: row;
  }
}
</style>
